import { render } from "./App.vue?vue&type=template&id=c748d0d6&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c748d0d6&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c748d0d6"]])

export default __exports__